"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpAssessmentTypeIcon: {
        assessment: 'Assessment',
        handout: 'Handout',
        diagnostic: 'Diagnostic',
        journal: 'Journal',
        practice: 'Practice',
    },
};
